export default "__VITE_ASSET__DxXbDhSw__"